<div class="nxt-block">
  <ng-container>
    <div class="row crud-container">
      <div class="form-group previewBtn">
        <button class="btn btn-default blue-outline-btn mr-07" (click)="previewMessage()">Preview</button>
      </div>
    </div>
  </ng-container>

  <div class="row crud-container">
    <div class="form-group inp-txt">
      <label *ngIf="!this.hideLabel" for="agentName">{{ label }} </label>

      <select
        name="messagetype"
        class="inp"
        [(ngModel)]="selectedMessageSource.value"
        (change)="onMessageSourceChange()"
      >
        <option label="Select one:" value="-1" selected></option>
        <option [value]="msg.value" *ngFor="let msg of messageSource">
          {{ msg.label }}
        </option>
      </select>
    </div>

    <div class="form-group inp-txt" *ngIf="this.selectedMessageSource.value === 'uploadfile'">
      <input
        class="form-control file-upload"
        accept=".mp3,audio/*"
        type="file"
        id="formFile"
        (change)="handleFileInput($event)"
      />
      <div
        [ngClass]="{
          loadingDotAnimation: savingAudioFileMessage === 'Saving File',
        }"
        class="audio-timer fs-hint"
      >
        {{ savingAudioFileMessage }}
      </div>
    </div>

    <div class="form-group col padl-0" *ngIf="this.selectedMessageSource.value === 'recording'">
      <button class="btn btn-danger btn-cancel record-btn" *ngIf="isRecording" (click)="startRecording()">
        <img alt="" src="{{ baseHref }}/assets/images/icon-mic.png" class="btn-img" /><span class="btn-text">
          Record</span
        >
      </button>
      <button *ngIf="!isRecording" class="btn btn-danger btn-cancel record-btn" (click)="stopRecording()">
        <img alt="" src="{{ baseHref }}/assets/images/icon-stop.png" class="btn-img" /><span class="btn-text">
          Stop</span
        >
      </button>

      <span class="audio-timer" *ngIf="!isRecording && !blobUrl">
        {{ recordedTime }}
      </span>
      <div class="audio-timer" *ngIf="savingRecordingFileMessage">
        {{ savingRecordingFileMessage }}
      </div>
    </div>
  </div>
</div>
